import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface ExternalRedirectProps {
  to: string
  fallbackPath?: string
}

export default function ExternalRedirect({
  to,
  fallbackPath = '/inventory',
}: ExternalRedirectProps) {
  const navigate = useNavigate()

  useEffect(() => {
    window.open(to, '_blank', 'noopener,noreferrer')

    navigate(fallbackPath, { replace: true })
  }, [to, fallbackPath, navigate])

  return null
}
